import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from '../../modules/nz-zorro-antd.module';
import { NgZorroIconModule } from '../../modules/nz-icon-antd.module';
import { FooterComponent } from './footer.component';
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
	declarations: [
		FooterComponent
	],
	imports: [
		CommonModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		NzPopoverModule,
		TranslateModule
	],
	exports: [
		FooterComponent
	]
})

export class FooterModule { }
